import { AuthenticationApi } from '@citruscamps/citrus-client'
import { useQuery, useQueryClient } from 'react-query'
import { generateApiConfig } from '../../../../../utils/client-config'
import { useState } from 'react'

interface ILogout {
  isLoading: boolean
  isError: boolean
}

export const useLogout = (): ILogout => {
  const [isFirst, setIsFirst] = useState<boolean>(true)
  const queryClient = useQueryClient()
  const { isLoading, isError } = useQuery(
    'logout',
    async ({ signal }) => {
      const authClient = new AuthenticationApi(generateApiConfig())
      try {
        await authClient.logoutAuth({ signal })
      } catch {}
      setIsFirst(false)
      if (isFirst) await queryClient.invalidateQueries()
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
    },
  )
  return {
    isLoading,
    isError,
  }
}
